var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_c('el-carousel',{attrs:{"interval":3000,"type":"card","height":"250px"}},_vm._l((_vm.picList),function(item){return _c('el-carousel-item',{key:item.bannerId},[_c('img',{attrs:{"src":item.pic}})])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }